import React from "react";

const Dashboard = () => (
  <div>
    <h4>Receptionist Dashboard</h4>
    <p>Welcome to the receptionist module. Use the menu to manage patients and appointments.</p>
  </div>
);

export default Dashboard;
